export default {
  login: {
    tagline: 'Advanced 3D Mesh Generation • Quality-Driven • Web-Optimized',
    agreePrefix: 'By logging in, you agree to our',
    termsOfService: 'Terms of Service',
    and: 'and',
    privacyPolicy: 'Privacy Policy',
    copyright: 'All rights reserved.',
  },
  resetPassword: {
    invalidLinkTitle: 'Invalid Reset Link',
    invalidLinkBody: 'This password reset link is invalid or has expired.',
    backToLogin: 'Back to login',
    subtitle: 'Reset your password',
    copyright: 'All rights reserved.',
  },
  oauthConsent: {
    title: '{{clientName}} wants to use your Khorium account',
    intro: 'If you allow it, {{clientName}} can:',
    scopes: {
      openid: 'Confirm who you are',
      email: 'See your email address',
      profile: 'See your name and profile picture',
    },
    notGranted: "These won't be granted: {{scopes}}",
    allow: 'Allow',
    deny: 'Deny',
    unknownApp: 'This app',
    loading: 'Checking the request…',
    redirecting: 'Returning you to the app…',
    done: 'You can close this tab and go back to the app.',
    errorTitle: 'Could not connect the app',
    errorBody: 'Go back to the app and start the connection again.',
  },
  verifyEmail: {
    nudgeManaged:
      'Email verification is pending with your organization. You can keep working in the meantime.',
  },
  appShell: {
    errorFallback: 'An unexpected error occurred.',
    errorTitle: 'Something went wrong',
    goToDashboard: 'Go to dashboard',
  },
} as const;
